import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Image, Segment } from 'semantic-ui-react';
import { Book } from './types';

interface BookComponetProps {
  isAdmin: boolean;
  book: Book;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

export const BookComponent = ({
  book,
  onDeleteClick,
  onEditClick,
  isAdmin,
}: BookComponetProps) => {
  return (
    <Segment>
      <Card>
        <Image
          as={Link}
          to={`/book/${book.id}`}
          src={book.picture}
          wrapped
          ui={false}
          label={
            book.available
              ? null
              : {
                  as: 'a',
                  icon: 'dont',
                  content: 'No Disponible',
                  ribbon: true,
                  color: 'red',
                  size: 'massive',
                }
          }
        />
        <Card.Content>
          <Card.Header>{book.name}</Card.Header>
          <Card.Meta>
            <span>{book.author}</span>
          </Card.Meta>
          <Card.Meta>
            <span>{book.genre}</span>
          </Card.Meta>
        </Card.Content>
        {isAdmin && (
          <Card.Content extra>
            <Button.Group>
              <Button onClick={onEditClick}>Edit</Button>
              <Button.Or />
              <Button onClick={onDeleteClick}>Delete</Button>
            </Button.Group>
          </Card.Content>
        )}
      </Card>
    </Segment>
  );
};
